import React from "react";
import { BrowseListingsParams } from "../../../services/api/LfgApi";
import styles from "./FilterControls.module.scss";

interface FilterControlsProps {
  filters: BrowseListingsParams;
  onChange: (filters: BrowseListingsParams) => void;
  games?: Array<{ gameId: string; name: string }>;
}

const FilterControls: React.FC<FilterControlsProps> = ({ filters, onChange, games }) => {
  const handleChange = (field: keyof BrowseListingsParams, value: string) => {
    onChange({
      ...filters,
      [field]: value || undefined,
      page: 1,
    });
  };

  return (
    <div className={styles.filterControls}>
      <select
        className={styles.filterSelect}
        value={filters.gameId || ""}
        onChange={(e) => handleChange("gameId", e.target.value)}
        aria-label="Filter by game"
      >
        <option value="">All games</option>
        {games?.map((game) => (
          <option key={game.gameId} value={game.gameId}>
            {game.name}
          </option>
        ))}
      </select>

      <select
        className={styles.filterSelect}
        value={filters.gameMode || ""}
        onChange={(e) => handleChange("gameMode", e.target.value)}
        aria-label="Filter by game mode"
      >
        <option value="">Any Mode</option>
        <option value="Ranked">Ranked</option>
        <option value="Casual">Casual</option>
        <option value="Custom">Custom</option>
      </select>

      <select
        className={styles.filterSelect}
        value={filters.region || ""}
        onChange={(e) => handleChange("region", e.target.value)}
        aria-label="Filter by region"
      >
        <option value="">Any Region</option>
        <option value="NA">NA</option>
        <option value="EU">EU</option>
        <option value="APAC">APAC</option>
        <option value="SA">SA</option>
      </select>

      <select
        className={styles.filterSelect}
        value={filters.skillLevel || ""}
        onChange={(e) => handleChange("skillLevel", e.target.value)}
        aria-label="Filter by skill level"
      >
        <option value="">Any Skill</option>
        <option value="casual">Casual</option>
        <option value="competitive">Competitive</option>
      </select>

      <select
        className={styles.filterSelect}
        value={filters.sort || "newest"}
        onChange={(e) => handleChange("sort", e.target.value)}
        aria-label="Sort listings"
      >
        <option value="newest">Newest</option>
        <option value="filling_soon">Filling Soon</option>
        <option value="closest_match">Closest Match</option>
      </select>
    </div>
  );
};

export default FilterControls;
